import React, { Component } from "react";
import moment from "moment";
import { Dialog } from "../../../components/Popup";
import ListingPage from "../../../containers/ListingPage";
import API from "../../../lib/api";
import { getMessage } from "../../../lib/translator";
import { Cell, Row } from "../../../components/Table";
import { getPrintableTime } from "../../../lib/datetime";
import DownloadIcon from "./download.svg";
import EmptyIcon from "./report-empty.svg";
import "./style.css";

const emptyState = {
  icon: EmptyIcon,
  message: getMessage("analytics.report.emptyState.message"),
};

const formatEntityName = (entity) => {
  if (!entity) return "";
  return entity
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const tableProperties = (isMobileView, handleDownload) => {
  return {
    headers: [
      getMessage("analytics.report.id"),
      getMessage("analytics.report.name"),
      getMessage("analytics.report.createdAt"),
      getMessage("analytics.report.duration"),
      getMessage("analytics.report.status"),
      getMessage("analytics.report.download"),
    ],
    row: (props) => {
      const { id, entity, startDate, endDate, status, type, createdAt } = props;
      const isDisabled = status !== "PROCESSED";

      return (
        <Row>
          <Cell className="report-id">
            {!isMobileView ? (
              <span className="report-id">{id}</span>
            ) : (
              <span className="text-muted">
                {`${getMessage("analytics.report.id")}: ${id}`}
              </span>
            )}
          </Cell>
          <Cell className="column-report-name report-name">
            {!isMobileView ? (
              formatEntityName(entity)
            ) : (
              <span className="text-muted">
                {`${getMessage("analytics.report.name")}: ${formatEntityName(
                  entity
                )}`}
              </span>
            )}
          </Cell>
          <Cell className="column-report-created report-created text-muted">
            {!isMobileView ? (
              createdAt ? (
                getPrintableTime(
                  moment
                    .utc(createdAt)
                    .utcOffset(3)
                    .format("YYYY-MM-DD HH:mm:ss")
                )
              ) : null
            ) : (
              <span className="text-muted">
                {`${getMessage("analytics.report.createdAt")}: ${
                  createdAt
                    ? getPrintableTime(
                        moment
                          .utc(createdAt)
                          .utcOffset(3)
                          .format("YYYY-MM-DD HH:mm:ss")
                      )
                    : ""
                }`}
              </span>
            )}
          </Cell>
          <Cell className="column-report-duration report-duration text-muted">
            {!isMobileView ? (
              `${startDate} : ${endDate}`
            ) : (
              <span className="text-muted">{`${startDate} : ${endDate}`}</span>
            )}
          </Cell>
          <Cell className="report-status">
            <span className={"text-muted"}>{status}</span>
          </Cell>
          <Cell className="report-actions">
            {type === "DOWNLOAD" && (
              <button
                className="download-button"
                onClick={() => handleDownload(id)}
                disabled={isDisabled}
              >
                <img
                  src={DownloadIcon}
                  alt={getMessage("analytics.report.download")}
                  className={`download-icon ${isDisabled ? "disabled" : ""}`}
                />
              </button>
            )}
          </Cell>
        </Row>
      );
    },
  };
};

export default class ReportsDownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileView: this.getMobileView(),
      showErrorDialog: false,
      formError: "",
    };
  }

  getMobileView() {
    return window.screen.width <= 480;
  }

  closeDialogs = () => {
    this.setState({
      showErrorDialog: false,
      formError: "",
    });
  };

  handleDownload = (id) => {
    this.setState({ showErrorDialog: false });

    const api = new API({
      url: `/bulk-processing-service/file-request/${id}/view-url`,
      responseType: "json",
    });

    api
      .get()
      .then((response) => {
        const fileUrl = response.data.fileUrl?.accessUrl;
        if (fileUrl) {
          window.open(fileUrl);
        } else {
          throw new Error("File URL not found");
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          showErrorDialog: true,
          formError: error?.message,
        });
      });
  };

  render() {
    const { showErrorDialog, formError } = this.state;
    return (
      <>
        <ListingPage
          helmetTitle="Zopping - Reports"
          className="reports-download-page"
          title={getMessage("analytics.report.title.reportsdownload")}
          api={{
            url: "/bulk-processing-service/file-request",
            transform: (response) => response.data.fileRequest,
          }}
          emptyState={emptyState}
          primaryKey="id"
          tableProperties={tableProperties(
            this.state.isMobileView,
            this.handleDownload
          )}
        ></ListingPage>
        <Dialog
          show={showErrorDialog}
          title={getMessage("error.generic")}
          information={getMessage(formError)}
          close={this.closeDialogs}
          closeText={getMessage("okay.text")}
        />
      </>
    );
  }
}
